<template>
  <b-modal
    id="modal-multi-3"
    size="sm"
    title="Confirmación"
    ok-only
    ok-title="Accept"
    v-model="$store.state.someVariables.showGenerarConfirmacion"
  >
    <b-card-text class="my-1">
      Una vez generados los horarios, quedarán registrados en el historial como
      fecha generada y no podrán modificarse. Se recomienda revisar toda la
      información antes de generar los horarios. <br />
      ¿ Deseas continuar ?
    </b-card-text>

    <template #modal-footer>
      <div class="w-100">
        <template v-if="!showLoading">
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            class="float-right"
            @click="saveAccion"
          >
            Aceptar
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="outline-primary"
            class="float-right mr-1"
            @click="close"
          >
            Cancelar
          </b-button>
        </template>
      </div>
    </template>
    <div v-if="showLoading" class="text-center mt-1">
      <b-spinner variant="primary" label="Text Centered" />
    </div>
  </b-modal>
</template>

<script>
import {
  BModal,
  BCardText,
  BButton,
  BSpinner,
  // xxx,
  // xxxx,
  // xxx,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import store from '@/store'
import { ref } from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  URL,
  USER,
  //   ROLES,
  //   ESTADO_JUGADOR,
  //   INSERT_DATA_PLAYER,
  //   INSERT_DATA_HISTORY_PLAYER,
  //   UPDATE_DATA_PLAYER,
} from '../../utils/variables'

export default {
  components: {
    BModal,
    BCardText,
    BButton,
    BSpinner,
  },
  directives: {
    // 'b-popover': VBPopover,
    // heightFade,
    Ripple,
  },
  props: {
    listPartidosEnviar: Array,
    historialSeleccionado: String,
    listSlots: Array,
  },
  setup(props, { emit }) {
    const { postApi } = apiCall()
    const showLoading = ref(false)
    async function guardarHorarios() {
      showLoading.value = true
      const data = {
        partidos: props.listPartidosEnviar,
        id_historial: props.historialSeleccionado,
        slots: props.listSlots,
        id_user: USER().id_usuario,
      }
      // console.log(data)
      const path = 'ApiFixture/generarHorariosInteligentes'
      const response = await postApi(URL, path, data)
      if (response.flag === 'si') {
        // console.log('eliminado')
        emit('guardadoHorarios')
      } else {
        emit('errorGuardarHorarios')
      }
      showLoading.value = false
      store.commit(
        'someVariables/UPDATE_SHOW_GENERAR_CONFIRMACION',
        // eslint-disable-next-line
        false,
      )
    }

    function saveAccion() {
      guardarHorarios()
    }

    function close() {
      store.commit(
        'someVariables/UPDATE_SHOW_DELETE_FIXTURE',
        // eslint-disable-next-line
        false,
      )
    }
    return {
      close,
      saveAccion,
      showLoading,
    }
  },
}
</script>
